
declare module "react/jsx-runtime" {
    namespace JSX {
        interface IntrinsicElements {
            "givebutter-widget": { id: string; };
        }
    }
}

export const GiveButterWidget: React.FC<{ id: string; }> = ({ id }) => {
    return (
        <givebutter-widget id={id}></givebutter-widget>
    );
}
